<template>
  <div id="app">
    <div id="nav">
      <!-- <p>brandName:{{brandname}}</p>
      <p>networkName:{{networkName}}</p> -->
      <!-- <p>brandbanner:{{brandbanner}}</p>
      <p>brandavatar:{{brandavatar}}</p> -->
      <!-- <img src="./assets/archimedix-logo.png" class="meditation"> -->
      <img :src="brandbanner" class="meditation">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>-->
    </div>

    <!-- <h2 v-html="'Address: ' + $root.address"></h2>
    <h2 v-html="'Network: ' + $root.networkName"></h2>-->
    <CashCard
      :payAddress="payaddress.toString()" 
      :networkName="networkName" 
      :brandName="brandname" 
      :balance="balance"
      :address="address"
      :defaultAmount="defaultamount"
      :imgAvatar="brandavatar"
      :cardBackground="cardbackground"
      :cardCircle1="cardcircle1"
      :cardCircle2="cardcircle2"
      :cardCircle3="cardcircle3"
      :backgroundNetwork="backgroundnetwork"
      >
    </CashCard>
    <!-- <router-view /> -->
    <section class="header" style="font-size:15px;margin-top:30px">
      <a href="https://metamask.io/">
        <img src="https://archimedix.net/components/img/metamask.png" alt="Metamask" class="browsers" width="120px">
      </a>
      <a href="https://wallet.coinbase.com/">
        <img src="https://archimedix.net/components/img/coinbase.png" alt="Coinbase" class="browsers" width="120px">
      </a>
      <a href="https://trustwallet.com/">
        <img src="https://archimedix.net/components/img/trust.png" alt="Trust Wallet" class="browsers" width="120px">
      </a>
    </section>
  </div>
</template>
<script>
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

import CashCard from "./components/cashCard";
export default {
  name: "app",
  props: {
    brandname: {
      type: String,
      default: "BrandName"
    },
    payaddress: {
      type: String,
      default: "0x527d3c89F057aA3C9150eD31914227BBD29Ef3aa"
    },
    brandbanner: {
      type: String,
      default: "https://archimedix.net/components/img/meditation.png"
    },
    brandavatar: {
      type: String,
      default: "https://archimedix.net/components/img/avatar.png"
    },
    defaultamount: {
      type: String,
      default: "0.1"
    },
    cardbackground: {
      type: String,
      default: "#F17022"
    },
    cardcircle1: {
      type: String,
      default: "#FDB815"
    },
    cardcircle2: {
      type: String,
      default: "#F48624"
    },
    cardcircle3: {
      type: String,
      default: "#F1782A"
    },
    backgroundnetwork: {
      type: String,
      default: "#5801FF"
    },
  },
  components: {
    CashCard
  },
  data() {
    return {
      coinMarketCupKey: "",
      networkNumber: Number(),
      networkName: "",
      address: "",
      balance: "",
      networks: [
        {
          id: 0,
          name: "Olympic"
        },
        {
          id: 1,
          name: "MainNet"
        },
        {
          id: 2,
          name: "Morden"
        },
        {
          id: 3,
          name: "Ropsten"
        },
        {
          id: 4,
          name: "Rinkeby"
        },
        {
          id: 42,
          name: "Kovan"
        }
      ]
    };
  },
  methods: {
    initWeb3() {
      if (typeof web3 !== "undefined") {
        const self = this;
        web3.eth.getAccounts(function(err, accounts) {
          self.address = accounts[0];
          self.networkNumber = Number(web3.version.network);
          self.networkName = self.networks.filter(
            net => net.id === self.networkNumber
          )[0].name;
          web3.eth.getBalance(accounts[0], function(err, balance) {
            self.balance =
              web3
                .fromWei(balance, "ether")
                .toFixed(4)
                .toString()
          });
        });
      }
    }
  },
  created: function() {
    this.coinMarketCupKey = process.env.COINMARKETCUPKEY;
    this.initWeb3();
  }
};
</script>

<style>
body {
  background: #ffffff;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 20px;
  margin: 20px 50px 20px 50px;
  background: #ffffff;
  border-radius: 12px;
}
#nav {
  padding: 10px;
}
.browsers {
  width: 120px;
  margin-right: 20px;
}
.meditation {
  margin: auto;
  margin-bottom: 0px;
  width: 230px;
}
</style>
